import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface IBusinessIconProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
}

export const BusinessIcon = ({ color, ...props }: IBusinessIconProps) => {
  const fill = color ?? COLORS['icon-base-500'];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.80933 11.2707C3.18245 6.23839 7.3836 2.27148 12.5113 2.27148C11.7029 2.27148 10.9832 2.62582 10.3911 3.16764C9.80204 3.70674 9.30421 4.45929 8.90155 5.34888C8.49652 6.24371 8.18191 7.2903 7.96897 8.42609C7.79827 9.33654 7.69439 10.2964 7.65976 11.2707H2.80933ZM2.80933 12.73H7.65976C7.69439 13.7044 7.79827 14.6642 7.96897 15.5746C8.18191 16.7104 8.49652 17.757 8.90155 18.6519C9.30421 19.5414 9.80204 20.294 10.3911 20.8331C10.9832 21.3749 11.7029 21.7292 12.5113 21.7292C7.3836 21.7292 3.18245 17.7623 2.80933 12.73Z"
        fill={fill}
      />
      <path
        d="M12.5113 3.629C12.2437 3.629 11.8981 3.74285 11.4961 4.11065C11.0913 4.48117 10.6859 5.06187 10.3278 5.85305C9.97208 6.63898 9.68322 7.58774 9.48444 8.64798C9.3279 9.48294 9.23079 10.368 9.19671 11.2707L15.8258 11.2707C15.7917 10.368 15.6946 9.48294 15.5381 8.64798C15.3393 7.58774 15.0504 6.63898 14.6947 5.85305C14.3366 5.06187 13.9313 4.48117 13.5264 4.11065C13.1245 3.74285 12.7788 3.629 12.5113 3.629Z"
        fill={fill}
      />
      <path
        d="M9.48444 15.3527C9.68322 16.413 9.97208 17.3618 10.3278 18.1477C10.6859 18.9389 11.0913 19.5196 11.4961 19.8901C11.8981 20.2579 12.2437 20.3717 12.5113 20.3717C12.7788 20.3717 13.1245 20.2579 13.5264 19.8901C13.9313 19.5196 14.3366 18.9389 14.6947 18.1477C15.0504 17.3618 15.3393 16.413 15.5381 15.3528C15.6946 14.5178 15.7917 13.6327 15.8258 12.73L9.19671 12.73C9.23079 13.6327 9.3279 14.5178 9.48444 15.3527Z"
        fill={fill}
      />
      <path
        d="M12.5113 2.27148C13.3196 2.27148 14.0393 2.62582 14.6314 3.16764C15.2205 3.70674 15.7183 4.45929 16.121 5.34888C16.526 6.24371 16.8406 7.29031 17.0536 8.42609C17.2242 9.33654 17.3281 10.2964 17.3628 11.2707H22.2132C21.8401 6.23839 17.6389 2.27148 12.5113 2.27148Z"
        fill={fill}
      />
      <path
        d="M17.0536 15.5746C16.8406 16.7104 16.526 17.757 16.121 18.6519C15.7183 19.5414 15.2205 20.294 14.6314 20.8331C14.0393 21.3749 13.3196 21.7292 12.5113 21.7292C17.6389 21.7292 21.8401 17.7623 22.2132 12.73H17.3628C17.3281 13.7044 17.2242 14.6642 17.0536 15.5746Z"
        fill={fill}
      />
    </svg>
  );
};
